// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lb-0";